export default __webpack_public_path__ + "lib/button-border-hover.acfabff5eed4b2a47e385a86c207fd2b.svg";